// extracted by mini-css-extract-plugin
module.exports = {"hero":"Home_hero__3WEft","overlay":"Home_overlay__iyyMX","loginHero":"Home_loginHero__3MifX","text":"Home_text__15PlK"};